import React from "react";
import Button from "../FormElements/Button";
import IconPlus from "../../Resources/svg/Icons/IconPlus";
import { CustomTable } from "../FormElements/CustomTable";
import IconDelete from "../../Resources/svg/Icons/IconDelete";
import IconEdit from "../../Resources/svg/Icons/IconEdit";
import { ButtonIcon } from "../FormElements/ButtonIcon";
import { CardTable } from "../FormElements/CardTable";
import { transformDate } from "../../Utils/utils";

interface StepBeneficiariesProps {
  handleOpenModalAddBeneficiaries: () => void;
  parients: any[];
  relationshipData: any[];
  saludData: any[];
  genrerData: any[];
  renderName: (value: string, data: any[]) => string;
  handleOpenModalEditBeneficiarie: (parient: any) => void;
  deleteParient: (parient: any) => void;
  nextActiveStep: (id: number) => void;
  objSendForm: any;
}

const StepBeneficiaries: React.FC<StepBeneficiariesProps> = ({
  handleOpenModalAddBeneficiaries,
  parients,
  relationshipData,
  saludData,
  genrerData,
  renderName,
  handleOpenModalEditBeneficiarie,
  deleteParient,
  nextActiveStep,
  objSendForm,
}) => {
  return (
    <div
      style={{
        minHeight: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            marginBottom: "24px",
          }}
        >
          <ButtonIcon
            icon={<IconPlus />}
            text="Agregar Beneficiario"
            onClick={handleOpenModalAddBeneficiaries}
          />
        </div>
        <div>
          <CustomTable
            headers={[
              { title: "PARENTESCO", width: 50 },
              { title: "SALUD", width: 50 },
              { title: "FECHA NAC.", width: 50 },
              { title: "SEXO", width: 50 },
              { title: "ACCIONES", width: 50 },
            ]}
            data={parients}
            renderItem={(parient: any) => (
              <React.Fragment key={parient.id}>
                <td>{renderName(parient.relationship, relationshipData)}</td>
                <td>{renderName(parient.sano, saludData)}</td>
                <td> {transformDate(parient.bornDate, true)}</td>
                <td> {parient.genrerBenefiarie}</td>
              </React.Fragment>
            )}
            actions={(parient) => (
              <div style={{ display: "flex", gap: "10px" }} key={parient.id}>
                <IconEdit
                  onClick={() => handleOpenModalEditBeneficiarie(parient)}
                />
                <IconDelete onClick={() => deleteParient(parient)} />
              </div>
            )}
          />
          {parients.map((parient: any) => (
            <CardTable key={parient.id}>
              <div className="card-table__box">
                <div className="flex">
                  <div className="w-50">
                    <span className="card-table__description">
                      Parentesco:
                    </span>
                  </div>
                  <div>
                    <span className="card-table__data">
                      {renderName(parient.relationship, relationshipData)}
                    </span>
                  </div>
                </div>
                <div className="flex">
                  <div className="w-50">
                    <span className="card-table__description">Salud:</span>
                  </div>
                  <span className="card-table__data">
                    {renderName(parient.sano, saludData)}
                  </span>
                </div>
                <div className="flex">
                  <div className="w-50">
                    <span className="card-table__description">
                      Fecha Nac.
                    </span>
                  </div>
                  <span className="card-table__data">{parient.bornDate}</span>
                </div>
                <div className="flex">
                  <div className="w-50">
                    <span className="card-table__description">Sexo</span>
                  </div>
                  <span className="card-table__data">
                    {renderName(parient.genrerBenefiarie, genrerData)}
                  </span>
                </div>
              </div>
            </CardTable>
          ))}
        </div>
      </div>
      <div className="button__container">
        <Button
          type="submit"
          disabled={
            objSendForm &&
            objSendForm.prestacion === "S" &&
            parients.length === 0
          }
          onClick={() => {
            nextActiveStep(3);
          }}
        >
          Continuar
        </Button>
      </div>
    </div>
  );
};

export default StepBeneficiaries;
